import React from 'react';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import { Typography } from 'fronton-react';
import { LinkWithGAClickButton } from '../../../link';
import {
  downloadCatalogCartBody,
  downloadCatalogCart,
  downloadCatalogCartIcon,
  downloadCatalogCartImage,
  downloadCatalogCartText,
} from './download-catalog-cart-styles';

type DownloadCatalogCartProps = {
  elementBlock: string;
  elementText: string;
};

export const DownloadCatalogCart: React.FC<DownloadCatalogCartProps> = ({ elementBlock, elementText }) => (
  <LinkWithGAClickButton
    className={downloadCatalogCart}
    elementBlock={elementBlock}
    elementName="Скачать каталог кухонь"
    elementText={elementText}
    href="https://storage.yandexcloud.net/leroymerlin-ru-landings-docs/kitchen/Catalog-Delinia-ID.pdf"
    target="_blank"
    title="Скачать каталог кухонь">
    <div className={downloadCatalogCartBody}>
      <DownloadSimpleIcon className={downloadCatalogCartIcon} type="outline" size="l" color="text-primary" />
      <Typography className={downloadCatalogCartText} variant="l" size="body_accent">
        Скачать каталог кухонь
      </Typography>
    </div>
    <img
      alt="Изображение каталога кухонь"
      className={downloadCatalogCartImage}
      src="https://cdn.leroymerlin.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen/gallery/catalog-icon.png/catalog-icon.png"
    />
  </LinkWithGAClickButton>
);
